import { render, staticRenderFns } from "./OrderShowDetailsCard.vue?vue&type=template&id=032f41ec"
import script from "./OrderShowDetailsCard.vue?vue&type=script&lang=ts"
export * from "./OrderShowDetailsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports